'use client'

import { X24 } from '@vinted/monochrome-icons'
import { Button, Cell, Divider, Dialog, Navigation, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isOpen: boolean
  isBundleComplaint?: boolean
  onClose: () => void
}

const ComplaintRefundsOrderSavingsModal = ({
  isOpen,
  onClose,
  isBundleComplaint = true,
}: Props) => {
  const translate = useTranslate('complaint_refunds_item_discounts')

  const bodyTranslationKey = isBundleComplaint ? 'bundle_body' : 'single_item_body'

  const handleClose = () => onClose()

  return (
    <Dialog show={isOpen}>
      <Navigation
        body={translate('title')}
        right={
          <Button
            inline
            iconName={X24}
            styling={Button.Styling.Flat}
            onClick={handleClose}
            aria={{ 'aria-label': translate('a11y.close') }}
          />
        }
      />
      <Divider />
      <Cell>
        <Text as="span" text={translate(bodyTranslationKey)} />
        <Spacer size={Spacer.Size.XLarge} />
        <Button text={translate('action')} styling={Button.Styling.Filled} onClick={handleClose} />
      </Cell>
    </Dialog>
  )
}

export default ComplaintRefundsOrderSavingsModal
